// Firebase app initialization — reads config from REACT_APP_ env vars.
// These values are safe to commit (they are public identifiers, not secrets).
// Authentication and security are enforced by Firebase Security Rules.

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAnalytics, isSupported as analyticsSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId:             process.env.REACT_APP_FIREBASE_APP_ID || '',
  measurementId:     process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '',
};

// Only initialize if a project ID is configured
let app            = null;
let auth           = null;
let db             = null;
let googleProvider = null;

if (firebaseConfig.projectId) {
  app  = initializeApp(firebaseConfig);
  auth = getAuth(app);

  // initializeFirestore must be called before any getFirestore() call.
  // experimentalForceLongPolling switches from WebChannel to HTTP long-polling,
  // avoiding the CORS error that blocks Firestore reads on localhost.
  db = initializeFirestore(app, {
    experimentalForceLongPolling: true,
  });

  googleProvider = new GoogleAuthProvider();
  googleProvider.setCustomParameters({ prompt: 'select_account' });

  if (process.env.REACT_APP_APPCHECK_SITE_KEY) {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(process.env.REACT_APP_APPCHECK_SITE_KEY),
      isTokenAutoRefreshEnabled: true,
    });
  }

  // GA4 collection (property G-FG66QT2ZJY via the Firebase link). Production
  // builds only — local .env carries the real measurementId, so dev/test
  // sessions would otherwise pollute the analytics data.
  if (firebaseConfig.measurementId && process.env.NODE_ENV === 'production') {
    analyticsSupported()
      .then((ok) => { if (ok) getAnalytics(app); })
      .catch(() => {});
  }
}

export { app as firebaseApp, auth, db as firestoreDb, googleProvider, firebaseConfig };
